import React from 'react';
import './DateInput.scss';

interface DateInputProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  width?: string;
}

const DateInput: React.FC<DateInputProps> = ({
  value,
  onChange,
  placeholder = 'YYYY/MM/DD',
  disabled = false,
  className = '',
  width = 'auto'
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <div className={`date-input ${className}`} style={{ width }}>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`date-input__field ${disabled ? 'date-input__field--disabled' : ''}`}
        aria-label="Effective date"
      />
    </div>
  );
};

export default DateInput;
